<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="LIMITACIONES Y OBSTÁCULOS" />

      <b-row align-h="center" class="mt-5">
        <b-col cols="10" lg="6">
          <ValidationObserver ref="mainObserver" v-slot="{ invalid }">
            <b-row align-h="center" class="mb-5">
              <div id="pa-limitations">
                <div class="diagram-container">
                  <img :src="limitationsImg" alt="limitations-img">
                  <div class="input li_obs_pres">
                    <b-radio-group v-model="form.li_obstaculos_present" size="lg">
                      <b-radio :value="true">Si</b-radio>
                      <b-radio :value="false">No</b-radio>
                    </b-radio-group>
                  </div>
                  <div class="input li_vigas_pres">
                    <b-radio-group  v-model="form.li_vigas_present" size="lg">
                      <b-radio :value="true">Si</b-radio>
                      <b-radio :value="false">No</b-radio>
                    </b-radio-group >
                  </div>
                  <div class="input li_firmeza_anclajes_pres">
                    <b-radio-group  v-model="form.li_firmeza_anclajes_present" size="lg">
                      <b-radio :value="true">Si</b-radio>
                      <b-radio :value="false">No</b-radio>
                    </b-radio-group >
                  </div>
                  <div class="input li_tomas_o_apagadores_pres">
                    <b-radio-group  v-model="form.li_tomas_o_apagadores_present" size="lg">
                      <b-radio :value="true">Si</b-radio>
                      <b-radio :value="false">No</b-radio>
                    </b-radio-group >
                  </div>
                  <div class="input li_desniveles_pres">
                    <b-radio-group  v-model="form.li_desniveles_present" size="lg">
                      <b-radio :value="true">Si</b-radio>
                      <b-radio :value="false">No</b-radio>
                    </b-radio-group >
                  </div>
                  <div class="input li_muretes_pres">
                    <b-radio-group  v-model="form.li_muretes_present" size="lg">
                      <b-radio :value="true">Si</b-radio>
                      <b-radio :value="false">No</b-radio>
                    </b-radio-group >
                  </div>
                  <div class="input li_rodapies_pres">
                    <b-radio-group  v-model="form.li_rodapies_present" size="lg">
                      <b-radio :value="true">Si</b-radio>
                      <b-radio :value="false">No</b-radio>
                    </b-radio-group >
                  </div>
                </div>
              </div>
            </b-row>

            <StepNotes
              :value="form.limitations_notes"
              @update-form="updateStepNotes"
            />

            <span class="d-none">{{ invalid }}</span>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import BlankIcon from '../BlankIcon'
import LimitationsImage from '../../../../../assets/images/puerta_automatica/limitations.png'
import StepNotes from '../StepNotes'

export default {
  name: 'Limitations',
  components: { BlankIcon, ConfiguratorStepTitle, ValidationObserver, ValidationProvider, StepNotes },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      form: {
        li_obstaculos_present: false,
        li_vigas_present: false,
        li_firmeza_anclajes_present: true,
        li_tomas_o_apagadores_present: false,
        li_desniveles_present: false,
        li_muretes_present: false,
        li_rodapies_present: false,
        limitations_notes: ''
      },
      limitationsImg: LimitationsImage
    }
  },
  mounted () {
    if (this.puerta) {
      // feed form with anden
      this.form.li_obstaculos_present = this.puerta.li_obstaculos_present
      this.form.li_vigas_present = this.puerta.li_vigas_present
      this.form.li_firmeza_anclajes_present = this.puerta.li_firmeza_anclajes_present
      this.form.li_tomas_o_apagadores_present = this.puerta.li_tomas_o_apagadores_present
      this.form.li_desniveles_present = this.puerta.li_desniveles_present
      this.form.li_muretes_present = this.puerta.li_muretes_present
      this.form.li_rodapies_present = this.puerta.li_rodapies_present
      this.form.limitations_notes = this.puerta.limitations_notes
    }
  },
  computed: {
    ...mapState({
      puerta: state => state.configurator.configurable
    }),
    ...mapGetters(['configuratorStepNumber'])
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable(this.form)
      return result
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => value !== this.puerta[key])
    },
    updateStepNotes (notes) {
      this.form.limitations_notes = notes
    }
  }
}
</script>

<style scoped lang="scss">
  #pa-limitations {
    display: flex;
    justify-content: center;
    align-items: center;
    .diagram-container {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 720px;
        width: 100%;
        height: auto;
        align-self: center;
      }
    }
    .input {
      position: absolute;
    }
    .li_obs_pres { left: 40%; top: 5%; }
    .li_vigas_pres { right: 7%; top: 9%; }
    .li_firmeza_anclajes_pres { right: 6%; top: 40%; }
    .li_tomas_o_apagadores_pres { left: 6%; bottom: 26%; }
    .li_desniveles_pres { right: 25%; bottom: 8%; }
    .li_muretes_pres { right: 4%; bottom: 16%; }
    .li_rodapies_pres { left: 46%; bottom: -6%; }
  }



  @media (max-width: 767.98px) {
    #pa-limitations {
      .diagram-container {
        img {
          width: 100%;
          height: auto;
        }
      }

      .li_obs_pres { left: 35%; top: 5%; }
      .li_vigas_pres { right: -1%; top: 9%; }
      .li_firmeza_anclajes_pres { right: 0%; top: 40%; }
      .li_tomas_o_apagadores_pres { left: 2%; bottom: 23%; }
      .li_desniveles_pres { right: 20%; bottom: 6%; }
      .li_muretes_pres { right: -3%; bottom: 14%; }
      .li_rodapies_pres { left: 42%; bottom: -8%; }
    }
  }
</style>
